/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * guard component for the newest versions of inquiry (>= 3)
 *
 *
 *
 * @author Evgeniy Naumov
 * @version 1.23.0
 * @since 1.23.0
 */

// if you want an older version of the modal inquiries, use - dispatch(openCreateInquiry()
// but keep in mind that older versions will be removed in the future

import { FC } from 'react';

import { useSelector } from 'react-redux';

import { makeSelectIsFeatureWithVersionEnabled } from '@/main/pages/PageAuth/selectors/authSelectors';

import { IModalRenderProps } from '../../modal/types/modalTypes';
import { AccessComponentKeyEnum, FeatureNameEnum } from '../../role/constants/guard/guardConstants';
import { makeSelectGuardComponentEnabled } from '../../role/selectors/guardSelector';
import { ICreateInquiryInitialise } from '../types';
import { CreateInquiryV3Modal } from './CreateInquiryV3Modal';
import { CreateInquiryV4Modal } from './CreateInquiryV4Modal';

export type TCreateInquiryModal = Pick<IModalRenderProps, 'onCloseModal'> & ICreateInquiryInitialise;

export const CreateInquiryModal: FC<TCreateInquiryModal> = (props) => {
    const isInquiriesEnabled = useSelector(makeSelectGuardComponentEnabled(AccessComponentKeyEnum.inquiries));
    const isInquiriesV4Enabled = useSelector(makeSelectIsFeatureWithVersionEnabled(FeatureNameEnum.INQUIRIES, 4));

    if (!isInquiriesEnabled) return null;

    if (isInquiriesV4Enabled) {
        return <CreateInquiryV4Modal {...props} />;
    }
    return <CreateInquiryV3Modal {...props} />;
};
